import {
	CheckedRadioIcon,
	TextIcon,
	CheckedCheckboxIcon,
} from "../../../resource/icons";

export const answerTypes = ["one", "multi", "text"];
export const backendTypeToAnswerType = {
	1: "one",
	2: "multi",
	3: "text",
};
export const questionTypeToBackendType = {
	one: 1,
	multi: 2,
	text: 3,
};

export const answerTypeMap = {
	choosing: 1,
	writing: 2,
};

export const defaultAnswerType = answerTypes[0];

export const answerTypeTexts = {
	one: "Один вариант ответа",
	multi: "Несколько вариантов ответа",
	text: "Ответ текстом",
};

export const answerTypeIcons = {
	one: CheckedRadioIcon,
	multi: CheckedCheckboxIcon,
	text: TextIcon,
};
